import React, { useState } from "react";
import { Modal, Select, Typography } from "antd";
import { connect } from "react-redux";
import MenuService from "services/MenuService";
import { setSelectedTenant } from "redux/actions/User";
import { UPDATE_USER } from "redux/constants/User";

const { Text } = Typography;

const TenantSelectionModal = ({
	visible,
	tenants,
	setSelectedTenant: setTenant,
	clearAwaitingTenantSelection,
}) => {
	const [selected, setSelected] = useState(undefined);
	const [confirming, setConfirming] = useState(false);

	const handleConfirm = async () => {
		if (!selected) {
			return;
		}

		setConfirming(true);
		try {
			await MenuService.applyTenantAndLoadMenu(selected);
			setTenant(selected);
			clearAwaitingTenantSelection();
		} finally {
			setConfirming(false);
		}
	};

	return (
		<Modal
			title="Selecione a empresa"
			open={visible}
			okText="Acessar"
			cancelButtonProps={{ style: { display: "none" } }}
			closable={false}
			maskClosable={false}
			okButtonProps={{ disabled: !selected, loading: confirming }}
			onOk={handleConfirm}
		>
			<Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
				Você tem acesso a mais de uma empresa. Escolha qual deseja utilizar nesta
				sessão.
			</Text>
			<Select
				showSearch
				placeholder="Empresa"
				style={{ width: "100%" }}
				value={selected}
				onChange={setSelected}
				optionFilterProp="label"
				options={(tenants || []).map((tenant) => ({
					value: tenant.nome_schema,
					label: `${tenant.nome} (${tenant.nome_schema})`,
				}))}
			/>
		</Modal>
	);
};

const mapStateToProps = ({ user }) => ({
	visible: Boolean(user?.awaitingTenantSelection),
	tenants: user?.tenants || [],
});

const mapDispatchToProps = (dispatch) => ({
	setSelectedTenant: (schema) => dispatch(setSelectedTenant(schema)),
	clearAwaitingTenantSelection: () =>
		dispatch({ type: UPDATE_USER, awaitingTenantSelection: false }),
});

export default connect(mapStateToProps, mapDispatchToProps)(TenantSelectionModal);
